module.exports = __webpack_public_path__ + "icons/original/large/large-f2.ebac4e572194ab532410773494ed9c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f2.png
// module id = zU+P
// module chunks = app